<template>
  <div class="lostpassword-view">
    <lostpassword-form />
  </div>
</template>

<script>

  import LostPasswordForm from 'brave-authentication/components/lostpassword'
  export default {
    name: 'LostPasswordView',
    components: {
      'lostpassword-form': LostPasswordForm
    }
  }
</script>


